module.exports = __webpack_public_path__ + "static/java-b48f9769e32e009e1119318dc9ebf353.png";